import React from "react";

const SvgClose = React.forwardRef((props, ref) => (
  <svg
    ref={ref}
    width="1em"
    height="1em"
    viewBox="0 0 17.769 17.768"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.401.367c.452.451.493 1.142.092 1.542L1.91 17.492c-.4.4-1.09.36-1.542-.092-.45-.451-.492-1.141-.092-1.541L15.86.275c.4-.4 1.09-.359 1.541.092z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.367.367C.818-.083 1.51-.125 1.91.275L17.492 15.86c.4.4.36 1.09-.092 1.541-.45.451-1.141.493-1.541.092L.275 1.91c-.4-.4-.359-1.09.092-1.542z"
      fill="currentColor"
    />
  </svg>
));

export default SvgClose;
